<template>
  <header>
    <div class="header-title">
      <img class="header-logo-img" src="../../../assets/img/logo.png" />
    </div>
    <div class="header-container clearfix">
      <div class="left header-function-box">
        <span class="header-icon" @click="sidebarToggle">
          <Icon
            class="iconsuojindaohang iconfont"
            color="#878787"
            size="20"
          ></Icon>
        </span>
        <span class="header-icon" @click="fullScreenToggle">
          <Icon
            class="iconquanpingmoshi iconfont"
            color="#878787"
            size="20"
          ></Icon>
        </span>
      </div>
      <div class="right m-right-sm">
        <div class="header-user-info">
          <!-- <Dropdown placement="bottom-end" class="header-message" @on-click="messageMenuClick" transfer>
            <Badge :count="notReadSystemMessageCount" :offset="[ 8, -3 ]" type="primary">
              <a href="javascript:void(0)" class="header-a"> -->
          <!-- {{$t('SYSTEM_MSG.name')}} -->
          <!-- <Icon class="iconzhanneixinxi iconfont" color='#878787' size="20"></Icon>
              </a>
            </Badge>
            <DropdownMenu slot="list">
              <DropdownItem name="received">
                <span class="m-left-xs">{{$t('SYSTEM_MSG.received')}}</span>
                <Badge :count="notReadSystemMessageCount"></Badge>
              </DropdownItem>
              <DropdownItem name="sent">
                <span class="m-left-xs">{{$t('SYSTEM_MSG.sent')}}</span>
              </DropdownItem>
            </DropdownMenu>
          </Dropdown> -->
          <!-- <lang-drop-menu class="header-lang"></lang-drop-menu> -->
          <Dropdown placement="bottom-end" @on-click="dropMenuClick" transfer>
            <img
              class="header-admin-img"
              src="../../../assets/img/guanliyuannan.png"
            />
            <a href="javascript:void(0)" class="header-a">
              <span>{{ admin.roleName }}</span>
              {{ admin.accountName }}
              <Icon type="ios-arrow-down"></Icon>
            </a>
            <DropdownMenu slot="list">
              <DropdownItem name="/personalCenter">
                <Icon type="md-person" :size="16"></Icon>
                <span class="m-left-xs">个人中心</span>
              </DropdownItem>
              <DropdownItem name="/switchRoles">
                <Icon type="md-person" :size="16"></Icon>
                <span class="m-left-xs">切换角色</span>
              </DropdownItem>
              <DropdownItem v-if="todoSystemList" name="/switchSystem">
                <Icon type="ios-settings" :size="16"></Icon>
                <span class="m-left-xs">系统切换页</span>
              </DropdownItem>
              <DropdownItem name="logout">
                <Icon type="md-power" :size="16"></Icon>
                <span class="m-left-xs">登出</span>
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
    </div>
    <Modal
      v-model="personalModalShow"
      width="460"
      title="个人中心"
      @on-cancel="personalModalShow = false"
      :mask-closable="false"
      :styles="{ top: '20px' }"
    >
      <Tabs
        type="card"
        name="header"
        style="overflow: hidden;"
        :animated="false"
      >
        <TabPane label="基本信息" tab="header">
          <Form
            :model="personalInfo"
            ref="personalInfoFormVali"
            :rules="ruleValidate"
            :label-width="85"
            label-position="right"
            style="padding-top: 16px;"
          >
            <FormItem label="账户名：">
              <span>{{ admin.accountName }}</span>
            </FormItem>
            <FormItem label="角色：">
              <!--              <span v-for="role in admin.roles" :key="role.name">{{role.name}}</span>-->
              <span>{{ admin.roleName }}</span>
            </FormItem>
            <FormItem label="组织机构：">
              <!-- <span v-for="org in admin.orgs" :key="org.name">{{org.name}}</span> -->
              <span>{{ admin.deptName }}</span>
            </FormItem>
            <FormItem label="工号：" prop="jobNumber">
              <Input
                v-model.trim="personalInfo.jobNumber"
                style="width: 200px;"
              />
            </FormItem>
            <FormItem label="姓名：" prop="name">
              <Input v-model.trim="personalInfo.name" style="width: 200px;" />
            </FormItem>
            <FormItem label="手机号：" prop="mobile">
              <Input v-model.trim="personalInfo.mobile" style="width: 200px;" />
            </FormItem>
            <FormItem label="邮箱：" prop="email">
              <Input v-model.trim="personalInfo.email" style="width: 200px;" />
            </FormItem>
            <FormItem style="margin-bottom: 0;">
              <Button
                type="primary"
                style="margin-right: 10px;"
                @click="savePersonalInfo"
              >
                应用
              </Button>
            </FormItem>
          </Form>
          <Spin size="large" fix v-show="loading.modalData"></Spin>
        </TabPane>
        <TabPane label="修改密码" tab="header">
          <Form
            :model="personalPwd"
            ref="personalPwdFormVali"
            :rules="ruleValidate"
            :label-width="75"
            label-position="right"
            style="padding-top: 16px;"
          >
            <FormItem label="旧密码：" prop="oldPassword">
              <Input
                :type="oldEye ? 'text' : 'password'"
                v-model="personalPwd.oldPassword"
                style="width: 200px;"
                clearable
              />
              <Icon
                :type="oldEye ? 'md-eye' : 'md-eye-off'"
                :size="20"
                @click="changeOldEye()"
              />
            </FormItem>
            <FormItem label="新密码：" prop="password">
              <Input
                :type="newEye ? 'text' : 'password'"
                v-model="personalPwd.password"
                style="width: 200px;"
                clearable
              />
              <Icon
                :type="newEye ? 'md-eye' : 'md-eye-off'"
                :size="20"
                @click="changeNewEye()"
              />
            </FormItem>
            <FormItem label="确认密码：" prop="confirmPassword">
              <Input
                :type="conEye ? 'text' : 'password'"
                v-model="personalPwd.confirmPassword"
                style="width: 200px;"
                clearable
              />
              <Icon
                :type="conEye ? 'md-eye' : 'md-eye-off'"
                :size="20"
                @click="changeConEye()"
              />
            </FormItem>
            <FormItem style="margin-bottom: 0;">
              <Button style="margin-right: 10px;" @click="clearPassWord"
                >重置
              </Button>
              <Button
                type="primary"
                style="margin-right: 10px;"
                @click="savePersonalPwd"
                >确认
              </Button>
            </FormItem>
          </Form>
        </TabPane>
      </Tabs>
      <div slot="footer"></div>
    </Modal>
    <!-- 首次登陆必需修改密码-->
    <Modal
      v-model="passwordModalShow"
      title="修改登录密码"
      :closable="false"
      :mask-closable="false"
      footer-hide
    >
      <div>
        <Form
          :model="personalPwd"
          ref="personalPwdFormVali"
          :rules="ruleValidate"
          :label-width="75"
          label-position="right"
        >
          <FormItem label="旧密码：" prop="oldPassword">
            <Input
              :type="oldEye ? 'text' : 'password'"
              v-model="personalPwd.oldPassword"
              style="width: 200px;"
              @on-blur="changePasswordCheck()"
              clearable
            />
            <Icon
              :type="oldEye ? 'md-eye' : 'md-eye-off'"
              :size="20"
              @click="changeOldEye()"
            />
          </FormItem>
          <FormItem label="新密码：" prop="password">
            <Input
              :type="newEye ? 'text' : 'password'"
              v-model="personalPwd.password"
              style="width: 200px;"
              @on-blur="changePasswordCheck()"
              clearable
            />
            <Icon
              :type="newEye ? 'md-eye' : 'md-eye-off'"
              :size="20"
              @click="changeNewEye()"
            />
          </FormItem>
          <FormItem label="确认密码：" prop="confirmPassword">
            <Input
              :type="conEye ? 'text' : 'password'"
              v-model="personalPwd.confirmPassword"
              style="width: 200px;"
              @on-blur="changePasswordCheck()"
              clearable
            />
            <Icon
              :type="conEye ? 'md-eye' : 'md-eye-off'"
              :size="20"
              @click="changeConEye()"
            />
          </FormItem>
          <FormItem style="margin-bottom: 0;">
            <Button style="margin-right: 10px;" @click="clearPassWord"
              >重置
            </Button>
            <Button
              type="primary"
              style="margin-right: 10px;"
              @click="savePersonalPwd"
              >确认
            </Button>
          </FormItem>
        </Form>
      </div>
    </Modal>
    <!--    角色切换-->
    <Modal
      v-model="rolesModelShow"
      title="角色切换"
      @on-ok="rolesConfirmOk"
      @on-cancel="rolesConfirmCancel"
    >
      <i-table
        :columns="rolesColumns"
        @on-current-change="roleTableAction"
        :highlight-row="true"
        :data="rolesList"
      ></i-table>
    </Modal>
  </header>
</template>
<script>
import _ from "lodash";
import { mapGetters, mapMutations } from "vuex";
import { checkBroser, httpAxios, getParam } from "../serve/header";
// import LangDropMenu from '../../component/LangDropMenu';
// import Service from '../../service';
// import { authAssign } from '../../helper/Auth.js';
import Bus from "../../../helper/Bus.js";
import * as api from "@/service";

export default {
  components: {},
  data() {
    return {
      appId: "1",
      oldEye: false,
      newEye: false,
      conEye: false,
      loading: {
        modalData: false,
      },
      admin: {
        username: "",
        roles: [],
      },
      mallObj: {},
      personalModalShow: false,
      passwordModalShow: false,
      rolesModelShow: false,
      personalInfo: {},
      personalPwd: {
        oldPassword: "",
        password: "",
        confirmPassword: "",
      },
      rolesList: [],
      selectObj: {},
      systemId: sessionStorage.getItem("systemId")
        ? sessionStorage.getItem("systemId")
        : "",
      roleValue: null,
      rolesColumns: [
        {
          title: "用户名",
          key: "roleName",
          minWidth: 120,
        },
        // {
        //   title: '描述',
        //   key: 'roleDesc',
        //   // minWidth: 140,
        // },
        {
          title: "描述",
          key: "",
          minWidth: 160,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    float: "left",
                    marginRight: "12px",
                  },
                },
                params.row.roleDesc
              ),
              h(
                "Checkbox",
                {
                  props: {
                    value: params.row.checkBox,
                  },
                  style: {
                    float: "right",
                  },
                  on: {
                    "on-change": (e) => {
                      this.rolesList.forEach((items) => {
                        //先取消所有对象的勾选，checkBox设置为false
                        this.$set(items, "checkBox", false);
                      });
                      if (e) {
                        this.selectObj = params.row;
                      } else {
                        this.selectObj = {};
                      }
                      console.log(this.selectObj);
                      this.rolesList[params.index].checkBox = e; //再将勾选的对象的checkBox设置为true
                    },
                  },
                },
                "默认角色"
              ),
            ]);
          },
        },
      ],
      systemList: sessionStorage.getItem("systemNum") || 0,
    };
  },
  computed: {
    ruleValidate() {
      return {
        jobNumber: [
          { required: true, message: "请输入工号" },
          { min: 2, max: 14, message: "工号 长度 2 - 14" },
        ],
        email: [
          { required: true, message: "请输入 邮箱" },
          {
            pattern: /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+\.){1,63}[a-z0-9]+$/,
            message: "请输入正确的 邮箱格式",
          },
        ],
        name: [
          { required: true, message: "请输入姓名" },
          { max: 14, min: 2, message: "姓名 长度 2 - 14" },
        ],
        mobile: [
          { required: true, message: "请输入手机号" },
          {
            pattern: /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/,
            message: "请输入正确的 手机号格式",
          },
        ],
        oldPassword: [
          { required: true, message: "请输入 旧密码" },
          { max: 30, min: 8, message: "旧密码 长度 8 - 30" },
        ],
        password: [
          { required: true, message: "请输入 新密码" },
          { max: 30, min: 8, message: "新密码 长度 8 - 30" },
          {
            pattern: /^(?![A-Za-z]+$)(?![A-Z\d]+$)(?![A-Z\W]+$)(?![a-z\d]+$)(?![a-z\W]+$)(?![\d\W]+$)\S{6,}$/,
            message: "至少包含大写字母、小写字母、数字、特殊字符中的3种",
          },
          {
            validator: (rule, value, cb) => {
              if (value == this.personalPwd.oldPassword) {
                cb(new Error("新密码不能与旧密码相同"));
              }
              cb();
            },
          },
        ],
        confirmPassword: [
          { required: true, message: "请输入 确认密码" },
          { max: 30, min: 8, message: "新密码 长度 8 - 30" },
          {
            pattern: /^(?![A-Za-z]+$)(?![A-Z\d]+$)(?![A-Z\W]+$)(?![a-z\d]+$)(?![a-z\W]+$)(?![\d\W]+$)\S{6,}$/,
            message: "至少包含大写字母、小写字母、数字、特殊字符中的3种",
          },
          {
            validator: (rule, value, cb) => {
              if (value !== this.personalPwd.password) {
                cb(new Error("两次密码输入不一致"));
              }
              cb();
            },
          },
        ],
      };
    },
    todoSystemList() {
      return (
        sessionStorage.getItem("bt_isSingle") === "true" &&
        sessionStorage.getItem("bt_systemList") === "true"
      );
    },
    ...mapGetters({
      menuSwitch: "getMenuSwitch",
      global: "getGlobal",
      notReadSystemMessageCount: "getNotReadSystemMessageCount",
      userInfo: "getUserInfo",
    }),
  },
  methods: {
    ...mapMutations({
      setNotReadSystemMessageCount: "SET_NOT_READ_SYSTEM_MESSAGE_COUNT",
      SET_ASIDEMENULIST: "SET_ASIDEMENULIST",
    }),
    // 点击确定切换角色
    async rolesConfirmOk() {
      await this.setDefaultRole();
      let id = this.roleValue ? this.roleValue.id : "";
      await this.setLastRole(id);
      this.initPersonalData(id);
    },
    // 点击取消切换角色
    rolesConfirmCancel() {},
    roleTableAction(value) {
      this.roleValue = value;
    },
    logout() {
      httpAxios();
    },
    sidebarToggle() {
      this.$store.commit("SET_MENU_TOGGLE");
    },
    fullScreenToggle() {
      this.$Message.info({
        content: "Esc键 关闭全屏模式",
        duration: 3,
      });
      this.$store.commit("SET_FULL_SCREEN_TOGGLE");
      const esc = (e) => {
        if (e.key === "Escape" || e.code === "Escape") {
          this.$store.commit("SET_FULL_SCREEN_TOGGLE");
          document.removeEventListener("keyup", esc); // 关闭全屏后清楚事件
        }
      };
      document.addEventListener("keyup", esc);
    },
    messageMenuClick(name) {
      if (name === "received") {
        this.$router.push("/systemMessage/received");
      } else {
        this.$router.push("/systemMessage/sent");
      }
    },
    dropMenuClick(name) {
      if (name === "logout") {
        this.$Modal.confirm({
          title: "提示",
          content: "确认要退出吗？",
          onOk: () => {
            this.logout();
          },
        });
      } else if (name === "/switchRoles") {
        this.showRolesModel();
      } else if (name === "/switchSystem") {
        this.switchSystemBack();
      } else {
        this.openPersonalModal();
      }
    },
    async switchSystemBack() {
      let params = {
        url: "",
        systemFlag: null,
      };
      await api.switchSystemBack(params);
    },
    // 获取登陆用户当前系统所有角色
    async getCurRolesList() {
      let params = {};
      params.systemFlag = 1;
      const res = await api.queryLoginRoleCurrentSystem(params);

      const data = _.get(res, "data.data");
      if (Array.isArray(data)) {
        this.rolesList = data;
      }
    },
    // 设置默认角色
    async setDefaultRole() {
      let params = {};
      params.defaultRoleId = this.selectObj.id ? this.selectObj.id : "";
      params.systemFlag = 1;
      const code = _.get(await api.setDefaultRole(params), "data.code");

      if (code === "000000") {
        this.$Notice.success({
          title: "操作成功",
        });
      } else {
        this.$Notice.warning({
          title: "操作失败",
        });
      }
    },
    // 切换角色
    async setLastRole(id) {
      let params = {};
      params.lastRoleId = id;
      params.systemFlag = 1;
      api.setLastRole(params).then((res) => {
        const result = res.data;
        if (result.code === "000000") {
        }
      });
    },
    // 切换角色模态框
    async showRolesModel() {
      await this.getCurRolesList();
      this.rolesList.map((item) => {
        //先取消所有对象的勾选，checkBox设置为false
        this.$set(item, "checkBox", item.isDefault ? true : false);
        console.log(item);
        if (item.isDefault === 1) {
          this.selectObj = item;
        }
      });
      console.log(this.selectObj);
      this.rolesModelShow = true;
    },
    openPersonalModal() {
      this.$refs.personalInfoFormVali.resetFields();
      this.$refs.personalPwdFormVali.resetFields();
      this.initPersonalData(this.userInfo.roleId);
      this.personalPwd = this.$options.data().personalPwd;
      this.personalModalShow = true;
    },
    savePersonalInfo() {
      this.$refs.personalInfoFormVali.validate((valid) => {
        if (valid) {
          let roles = this.rolesList.map((item) => {
            return item.id;
          });
          let params = {
            deptId: this.admin.deptId,
            deptName: this.admin.accountName,
            email: this.personalInfo.email,
            gender: this.admin.gender,
            id: this.admin.accountId,
            name: this.personalInfo.name,
            phone: this.personalInfo.mobile,
            // "roleIds":roles,
            staffNo: this.personalInfo.jobNumber,
          };
          api.updatePlatUser(params).then((res) => {
            const result = res.data;
            if (result.code === "000000") {
              this.initPersonalData(this.userInfo.roleId);
              this.$Notice.success({
                title: "操作成功",
              });
              this.personalModalShow = false;
            } else {
              this.$Notice.warning({
                title: result.description,
              });
            }
          });
        }
      });
    },
    changePasswordCheck() {
      this.$refs.personalPwdFormVali.validateField("oldPassword");
      this.$refs.personalPwdFormVali.validateField("password");
      this.$refs.personalPwdFormVali.validateField("confirmPassword");
    },
    savePersonalPwd() {
      this.$refs.personalPwdFormVali.validate((valid) => {
        if (valid) {
          let params = this.personalPwd;
          if (this.admin.loginTimes === "new") {
            params.loginTimes = "old";
          }
          let sedParams = {
            checkPassword: this.$md5(this.personalPwd.confirmPassword),
            id: this.admin.accountId,
            password: this.$md5(this.personalPwd.password),
            oldPassword: this.$md5(this.personalPwd.oldPassword),
          };
          api.changePassword(sedParams).then((res) => {
            const result = res.data;
            if (result.code === "000000") {
              this.personalModalShow = false;
              this.passwordModalShow = false;
              this.$Notice.success({
                title: "修改密码成功，3秒后返回登录界面",
                duration: 3,
                onClose: () => {
                  httpAxios();
                },
              });
            } else {
              this.$Notice.warning({
                title: "编辑失败" + result.description,
              });
            }
          });
        }
      });
    },
    async initPersonalData(roleId) {
      this.loading.modalData = true;
      let params = {};
      params.id = roleId
        ? roleId
        : sessionStorage.getItem("PRIVATE_USER_ROLEID")
        ? sessionStorage.getItem("PRIVATE_USER_ROLEID")
        : "";
      if (!params.id) {
        params.isLogin = 1;
      }

      const result = await api.queryLoginBaseInfoV2(params);
      if (result.code === "000000") {
        this.admin = result.data;
        this.SET_ASIDEMENULIST(result.data.menus);
        this.admin.roleName = this.userInfo.authRoleObj.roleName;
        this.admin.authRoleObj = this.userInfo.authRoleObj;
        this.personalInfo = {
          name: this.admin.name,
          mobile: this.admin.phone,
          email: this.admin.email,
          jobNumber: this.admin.staffNo,
        };
        this.loading.modalData = false;
      } else {
        sessionStorage.clear();
        this.$router.push("/login");
        this.loading.modalData = false;
      }
    },
    changeOldEye() {
      this.oldEye = !this.oldEye;
    },
    changeNewEye() {
      this.newEye = !this.newEye;
    },
    changeConEye() {
      this.conEye = !this.conEye;
    },
    clearPassWord() {
      this.personalPwd.oldPassword = "";
      this.personalPwd.password = "";
      this.personalPwd.confirmPassword = "";
      this.$refs.personalPwdFormVali.resetFields();
    },
  },
  created() {
    if (sessionStorage.getItem("dashboard-token")) {
      this.initPersonalData();
    }

    this.$EventBus.$off("personalInfo");
    this.$EventBus.$on("personalInfo", (data) => {
      if (data) {
        api.commitUserInfo(data, "");
        // 原逻辑
        this.admin = data;
        this.admin.roleName = data.authRoleObj.roleName;
        this.admin.authRoleObj = data.authRoleObj;
        this.personalInfo = {
          name: this.admin.name,
          mobile: this.admin.phone,
          email: this.admin.email,
          jobNumber: this.admin.staffNo,
        };
        if (!this.admin.pwdLastSet) {
          this.passwordModalShow = true;
        }
      }
    });
  },
};
</script>
<style lang="less">
@import "../../../assets/less/variable";
header {
  color: @text-color65;
  // color: red;
  background: @main-gray-bgcolor;
  &::after {
    content: "";
    display: block;
    height: 0;
    clear: both;
  }
  box-shadow: 0px 1px 0px 0px rgba(212, 215, 217, 1);
  transition: all 0.5s ease;
  .header-title {
    cursor: pointer;
    position: relative;
    float: left;
    width: @view-left;
    text-align: center;
    .header-logo-img {
      height: 28px;
      vertical-align: bottom;
      margin-top: 13px;
    }
    .brand-cn {
      font-size: 18px;
      font-weight: 600;
      line-height: @view-top;
      letter-spacing: 16px;
    }
    .brand-en {
      font-size: 18px;
      font-weight: 600;
      line-height: @view-top;
    }
  }
  .header-container {
    margin-left: @view-left;
    .header-function-box {
      margin-top: 17px;
      margin-left: 24px;
      .header-icon {
        display: inline-block;
        margin-left: 24px;
        cursor: pointer;
      }
    }
    .header-user-info {
      position: relative;
      float: left;
      margin-right: 20px;
      padding: (@view-top - 32)/2 0;
      outline: none;
      margin-left: 10px;
      line-height: 32px;
      display: flex;
      .header-message {
        a {
          color: @text-color65;
          &:hover {
            color: @text-color65;
          }
        }
        margin-right: 50px;
      }
      .header-lang {
        a {
          color: @text-color65;
          &:hover {
            color: @text-color65;
          }
        }
        margin-right: 50px;
      }
      .header-admin-img {
        width: 24px;
        height: 24px;
        margin-right: 7px;
      }
      .header-a {
        color: @text-color65;
      }
      .user-role {
        margin-right: 10px;
      }
    }
  }
}
.ivu-modal {
  overflow: hidden;
}
.ivu-dropdown-rel {
  display: flex;
  align-items: center;
}
</style>
